import { Typography } from '@breetometer/components';

export const ScreenShotHeader = ({ title }: { title: string }) => (
	<div
		className='screenshot-mode_header border-bottom-dark-navy show-during-screenshot flex'
		data-testid='screenshot-header'
	>
		<Typography
			as='h3'
			className='color-neutral-50'
		>
			{title}
		</Typography>
	</div>
);
